/*@ngInject*/
const FormSetMediator = function (formSetRepository) {

    this.startChanges = function (formSetId) {
        return formSetRepository.startChanges(formSetId);
    };

    this.applyChanges = function (formSetId) {
        return formSetRepository.applyChanges(formSetId);
    };

    this.discardChanges = function (formSetId) {
        return formSetRepository.discardChanges(formSetId);
    };
};

angular.module('umCore')
    .service('formSetMediator', FormSetMediator);
